import React, {Component} from 'react';

import JobSiteTest from './components/JobSiteTest';
import SpitTech from './components/SpitTech';

import { setMasonryDefinitionType } from '@reducers/selectors/material/actions';
import { connect } from 'react-redux';
import { APP_TEXTS } from '@texts';
import { BRAND } from '@config';
import { brandList } from './../../../../app.values';
import Popup from 'reactjs-popup';
import './styles.scss';

export const TABS = {
  SPIT_TECH: 'SPIT Technical data',
  JOB_SITE: 'Job site test'
};

class Masonry extends Component {

  // componentDidMount() {
  //   if (!this.props.definitionType) this.props.setDefinitionType(TABS.SPIT_TECH);
  // }
  constructor(props) {
    super(props);
    
    this.state = {
      displayJobSiteTestMsg: false
    };
  }

  render () {
    return (
      <React.Fragment>
        <div className="calculation design-and-combined-loading">
          {BRAND !== brandList.Ramset && BRAND !== brandList.Redhead && (
            <section className="list-type">
              <div className="btn-group">
                <button
                  className={`btn ${this.isSpitTechActive && "ToggleButton--active"}`}
                  onClick={() => this.props.setDefinitionType(TABS.SPIT_TECH)}
                >
                  {BRAND === brandList.Spit ? APP_TEXTS.MATERIAL_SPIT_TECHNICAL_DATA.Content : APP_TEXTS.MATERIAL_TECHNICAL_DATA.Content}
                </button>

                <button
                  className={`btn ${this.isJobSiteTestActive && "ToggleButton--active"}`}
                  onClick={() => {
                    if (!this.isJobSiteTestActive)
                      this.setState({ displayJobSiteTestMsg: true });
                    this.props.setDefinitionType(TABS.JOB_SITE);
                  }}
                >
                  {APP_TEXTS.MATERIAL_JOB_SITE_TEST.Content}
                </button>
              </div>
            </section>
          )}

          { this.isSpitTechActive && (
            <SpitTech />
          )}
          { this.isJobSiteTestActive && (
            <JobSiteTest />
          )}
        </div>

        <Popup // Job site test
          className="job_site_test_popup default_popup"
          modal={true}
          open={this.state.displayJobSiteTestMsg}
          closeOnDocumentClick={false}
        >
        {close => (        
          <React.Fragment>
            <h4 className="default_popup-header mb-2 ml-2">{APP_TEXTS.MATERIAL_JOB_SITE_TEST.Content}</h4>
            <section className="list-type default_popup-text">
              <div className="content mt-2">
                <p>{APP_TEXTS.MATERIAL_JOB_SITE_TEST_POPUP_CONTENT.Content}</p>
              </div>
            </section>
            <div className="default_popup-footer mt-2">
              <button
                className="btn btn-sm support_popup-button default_popup-button"
                onClick={() => {
                  this.setState({ displayJobSiteTestMsg: false });
                  close();
                }}
              >
                {APP_TEXTS.ANCHOR_SELECTION_OK.Content}
              </button>
            </div>
          </React.Fragment>
        )}
        </Popup>
      </React.Fragment>
    );
  }

  get isSpitTechActive() {
    return this.props.definitionType === TABS.SPIT_TECH;
}

  get isJobSiteTestActive() {
    return this.props.definitionType === TABS.JOB_SITE;
  }

}



const mapState = state => {
  if (state.selectors.material[state.main.appType].hasOwnProperty('masonry'))
    return {
      definitionType: state.selectors.material[state.main.appType].masonry.masonryDefinitionType
    };
  else 
    return {};
};

const mapDispatch = dispatch => ({
  setDefinitionType: value => dispatch(setMasonryDefinitionType(value))
});

export default connect(mapState, mapDispatch)(Masonry);



// WEBPACK FOOTER //
// ./src/views/Material/components/Masonry/index.js